
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ConsentService from "@/app/service/consent";
import IConsentResponse from "@/app/dto/IConsentResponse";
import IApiError from "@/app/model/IApiError";
import RouteName from "@/app/router/NameEnum";
import ProcessResultKey from "@/app/dto/ProcessResultKeyEnum";

@Component
export default class LoginConsent extends Vue {
    @Prop({ type: String }) token!: string;
    @Prop({ type: String }) clientId!: string;
    @Prop({ type: String }) responseType!: string;
    @Prop({ type: String }) redirectUri!: string;

    private submitting: boolean = false;

    private authorize(consented: boolean) {
        this.submitting = true;
        ConsentService.authorize(this.token, this.clientId, this.responseType, consented, this.redirectUri)
            .then((response: IConsentResponse) => {
                window.location.replace(response.redirectUrl);
            })
            .catch((error: IApiError) => {
                this.processConsentError(error);
            })
            .finally(() => {
                this.submitting = false;
            });
    }

    private processConsentError(error: IApiError): void {
        let errorHeading: string = "";
        let errorMessage: string = "";

        if (error.status == ProcessResultKey.REQUIRED_REDIRECT_URI) {
            errorHeading = this.$localize("error.consent.title");
            errorMessage = this.$localize("error.consent.redirect_uri");
        }
        this.routeToError({ heading: errorHeading, message: errorMessage });
    }

    private routeToError(params?: { heading: string; message: string }): void {
        this.$router.push({ name: RouteName.LOGIN_ERROR, params });
    }
}
